module.exports = __webpack_public_path__ + "img/bg.e8f6f9e8.png";